/**
 * 公共类部件
 */
import React, { useEffect } from "react";
import NoviceGuide from "Widgets/NoviceGuide";
import ExternalLinks from "Widgets/ExternalLinks";
import AppGroup from "../AppGroup";
import QuickLaunch from "Widgets/QuickLaunch";
import { PUB_WIDGET_APPCODES } from "../utilService";
import platform from "Pub/js/platform";
const { PubSub } = platform;

function CreaterPubWidget(props) {
    const { appOption } = props;

    useEffect(() => {
        PubSub.publish("linkageWidgetMounted", appOption.cardid);
    }, []);

    //渲染公共类部件
    const pubWidgetMap = {
        //新手引导
        [PUB_WIDGET_APPCODES.noviceGuide]: <NoviceGuide {...props} />,
        //常用应用
        [PUB_WIDGET_APPCODES.commonUsedApp]: <AppGroup key={appOption.cardid} id={appOption.cardid} {...props} />,
        //外部链接
        [PUB_WIDGET_APPCODES.externalLinks]: <ExternalLinks defaultName={appOption.name} id={appOption.cardid} {...props}/>,
        // 快速发起
        [PUB_WIDGET_APPCODES.quickLaunch]: <QuickLaunch key={appOption.cardid} id={appOption.cardid} {...props} />,
    };

    return pubWidgetMap[appOption.source_app_code || appOption.appcode];
}
export default CreaterPubWidget;
